import React from 'react'
import './styles.scss'

function AnswerType7({answers = []}) {
  return (
    <div className='AnswerType7V'>
      {answers.map(_i => <div key={_i._id} className='block'>
        <div className='itemBlockT7'>{_i.question}</div>
        <div className='line' />
        <div className='itemBlockT7'>{_i.answer}</div>
      </div>)}
    </div>
  )
}

export default AnswerType7


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/components/AnswerType7/AnswerType7.jsx